'use client';

export { SplitFormWrapper } from '../styled';
import styled from 'styled-components';
import { colors } from '@/styles';

export const RunForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  .prompt-display {
    position: relative;
    max-height: 120px;
  }
`;
